import {
  MISLABORATORIOS_SUCCESS,
  MISLABORATORIOS_LOADING,
  MISLABORATORIOS_ERROR,
  MISLABORATORIOS_RESET,
  MISLABORATORIOS_ARCHIVOBASE64LABO,
  MISLABORATORIOS_RESET_ARCHIVOBASE64LABO,
} from "../../ActionTypes";

import axiosLogin from "../../../../global/helpers/axiosLogin";

/* export const wsGetMisLaboratorios =
  (idPacFamiliar, filtroFecha, nextStep) => (dispatch) => {
    dispatch({ type: MISLABORATORIOS_LOADING });
    axiosInstance().then((respuesta) => {
      respuesta
        .get(
          `/laboratorio/${!idPacFamiliar ? "" : idPacFamiliar}/${
            !filtroFecha ? filtroFecha : ""
          }`
        )
        .then((resp) => {
          dispatch({
            type: MISLABORATORIOS_SUCCESS,
            payload: resp.data,
          });
          if (nextStep) nextStep(true, resp.data);
        })
        .catch((err) => {
          dispatch({ type: MISLABORATORIOS_ERROR, payload: err.data });
          if (nextStep) nextStep(false, err.response.data);
        });
    });
  }; */
export const wsGetMisLaboratorios =
  (idPacFamiliar, filtroFecha, nextStep) => (dispatch) => {
    dispatch({ type: MISLABORATORIOS_LOADING });
    axiosLogin().then((respuesta) => {
      respuesta
        .get(
          `lis/laboratorio/${!idPacFamiliar ? "" : idPacFamiliar}/${
            !filtroFecha ? filtroFecha : ""
          }`
        )
        .then((resp) => {
          dispatch({
            type: MISLABORATORIOS_SUCCESS,
            payload: resp.data,
          });
          if (nextStep) nextStep(true, resp.data);
        })
        .catch((err) => {
          dispatch({ type: MISLABORATORIOS_ERROR, payload: err.data });
          if (nextStep) nextStep(false, err.response.data);
        });
    });
  };

export const wsGetMisLaboratoriosSimplify =
  (idPacFamiliar, filtroFecha, nextStep) => (dispatch) => {
    dispatch({ type: MISLABORATORIOS_LOADING });
    axiosLogin().then((respuesta) => {
      respuesta
        .get(
          `lis/laboratorio/simplificado/${
            !idPacFamiliar ? "" : idPacFamiliar
          }/false`
        )
        .then((resp) => {
          dispatch({
            type: MISLABORATORIOS_SUCCESS,
            payload: resp.data,
          });
          if (nextStep) nextStep(true, resp.data);
        })
        .catch((err) => {
          dispatch({ type: MISLABORATORIOS_ERROR, payload: err.data });
          if (nextStep) nextStep(false, err.response.data);
        });
    });
  };

/* export const wsGetResultadoLaboratorio =
  (idProtocolo, nextStep) => (dispatch) => {
    dispatch({ type: MISLABORATORIOS_LOADING });
    axiosInstance().then((respuesta) => {
      respuesta
        .get(`/laboratorio/ImprimirResultadosProtocolo/${idProtocolo}`)
        .then((resp) => {
          dispatch({
            type: MISLABORATORIOS_ARCHIVOBASE64LABO,
            payload: resp.data,
          });
          if (nextStep) nextStep(true, resp.data);
        })
        .catch((err) => {
          dispatch({ type: MISLABORATORIOS_ERROR, payload: err.data });
          if (nextStep) nextStep(false, err.response.data);
        });
    });
  }; */

export const wsGetResultadoLaboratorio =
  (idProtocolo, nextStep) => (dispatch) => {
    dispatch({ type: MISLABORATORIOS_LOADING });
    axiosLogin().then((respuesta) => {
      respuesta
        .get(`lis/laboratorio/ImprimirResultadosProtocolo/${idProtocolo}/pdf`, {
          responseType: "blob",
        })
        .then((resp) => {
          const blob = resp.data; // PDF
          dispatch({ type: MISLABORATORIOS_ARCHIVOBASE64LABO, payload: null });
          if (nextStep) nextStep(true, { blob });
        })
        .catch(async (err) => {
          // Tengo que hacer esto para poder capturar el mensaje de error que me envía el backend
          const res = err?.response;
          let message = "Error al obtener PDF";

          if (res?.data instanceof Blob) {
            const ct = String(
              res.headers?.["content-type"] || ""
            ).toLowerCase();
            if (ct.includes("application/problem+json")) {
              // El backend devolvió JSON de error dentro de un Blob
              const text = await res.data.text();
              try {
                const json = JSON.parse(text);
                message = json.detail || message || json.title;
              } catch {
                message = text || message;
              }
            }
          }

          dispatch({
            type: MISLABORATORIOS_ERROR,
            payload: message,
          });
          if (nextStep) nextStep(false, message);
        });
    });
  };

export const misLaboratoriosReset = () => (dispatch) => {
  dispatch({
    type: MISLABORATORIOS_RESET,
  });
};
export const resetBase64Labo = () => (dispatch) => {
  dispatch({
    type: MISLABORATORIOS_RESET_ARCHIVOBASE64LABO,
  });
};
